import { Grid, Paper, Typography, Stack, Box, Tabs, Tab } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";

import TableCellConfigurations from "../../../Components/Table/TableCellConfigurations/table-cell-configurations";
import TableCellChip from "../../../Components/Table/TableCellChip/table-cell-chip";
import TableCellMultipleCover from "../../../Components/Table/TableCellMultipleCover/table-cell-multiple-cover";
import TableCellDueDate from "../../../Components/Table/TableCellDueDate/TableCellDueDate";
import TableCellMovie from "../../../Components/Table/TableCellMovie/table-cell-movie";
import TableCellMultipleSelect from "../../../Components/Table/TableCellMultipleSelect/table-cell-multiple-select";
import TableCellOrderStatus from "../../../Components/Table/TableCellOrderStatus/table-cell-order-status";
import TableCellQuality from "../../../Components/Table/TableCellQuality";
import TableCellPackageBundleStatus, {
  AssetSelectStatus,
} from "../../../Components/Table/TableCellPackageBundleStatus";
import { useSelection } from "../../../Utils/Hooks/useSelection";

import TableCellDescription from "../../../Components/Table/TableCellDescription";
import TableCellProgressBar from "../../../Components/Table/TableCellProgressBar";
import TableCellIconChip from "../../../Components/Table/TableCellIconChip";
import ContentsTable from "../../../Components/Table/ContentsTable/contents-table";
import TitlesTable from "../../../Components/Table/TitlesTable/titles-table";

import BrowsingData from "../../../Static/Data/browsing.json";
import TitleData from "../../../Static/Data/title.json";
import TableCellProviderStatus from "../../../Components/Table/TableCellProviderStatus";
import TableCellShareStatus from "../../../Components/Table/TableCellShareStatus/table-cell-share-status";
import TableCellName from "../../../Components/Table/TableCellName";
import TableCellUserGroups from "../../../Components/Table/TableCellUserGroups/table-cell-user-groups";
import TableSkeleton from "../../../Components/Table/TableSkeleton";
import { GroupRole } from "../../../Core/Api/Types/group-role";
import { ObjectType } from "../../../Core/Api/Types/object-type";
import TableCellAsset from "../../../Components/Table/TableCellAsset/table-cell-asset";
import { useTranslation } from "react-i18next";

function DemoTables() {
  const { t } = useTranslation();
  const { selected: expandedGroupColumn, select: onChangeExpandedGroupColumn } = useSelection("overview");

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mt: 4, display: "flex", flexDirection: "column", backgroundImage: "none" }}>
            <h1 id="table-cells">{t("page:body.tablesCells")}</h1>
            <Grid container spacing={3}>
              <Grid item md={4}>
                <h2 id="cell-configuration">{t("page:body.cellConfigurations")}</h2>
                <TableCellConfigurations data={null} />
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-chip">{t("page:body.cellChip")}</h2>
                <Stack alignItems="flex-start" spacing={1}>
                  <Box>
                    <TableCellChip data={{ value: ["Chip 1", "Chip 2"] }} color="primary" />
                  </Box>
                  <Box>
                    <TableCellChip data={{ value: ["Chip 1", "Chip 2"] }} />
                  </Box>
                  <Box>
                    <TableCellIconChip
                      data={{
                        value: [
                          { text: "Chip 1", icon: SubtitlesOutlinedIcon },
                          { text: "Chip 2", icon: SubtitlesOutlinedIcon },
                        ],
                      }}
                    />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-duedate">{t("page:body.cellDuedate")}</h2>
                <TableCellDueDate
                  data={{
                    value: "2022-08-13T16:35:23.993Z",
                  }}
                />
                <TableCellDueDate
                  data={{
                    value: "2022-09-15T16:35:23.993Z",
                  }}
                />
                <TableCellDueDate
                  data={{
                    value: "2022-12-13T16:35:23.993Z",
                  }}
                />
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-covers">{t("page:body.cellCovers")}</h2>
                <TableCellMultipleCover
                  data={{
                    value: [
                      { id: 1, thumbnail: "/static/images/temp/movie-cover-1.jpg", title: "Stranger things" },
                      { id: 2, thumbnail: "/static/images/temp/movie-cover-2.jpg", title: "Stranger things" },
                      { id: 3, thumbnail: "/static/images/temp/movie-cover-3.jpg", title: "Stranger things" },
                    ],
                  }}
                />
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-movie">{t("page:body.cellMovie")}</h2>
                <TableCellMovie name="Stranger things Saison 4" id={1234} />
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-asset">{t("page:body.cellAsset")}</h2>
                <Box>
                  {/* Fix this : enum doesn't work as param */}
                  <TableCellAsset
                    data={{
                      row: {
                        title: "Stranger things Saison 4",
                        desc: "DREAMERS WITHIN THE DREAM : LA GENÈSE DE TOTAL ",
                        type: ObjectType.Video,
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-mutliple-select">{t("page:body.multipleSelect")}</h2>
                {/* <TableCellMultipleSelect
                  options={[
                    { label: "Option 1", value: "option" },
                    { label: "Trailer - Short version", value: "Trailer - Short version" },
                    { label: "Subtitle Burn", value: "Subtitle Burn" },
                  ]}
                  data={{
                    value: ["Trailer - Short version", "Subtitle Burn"],
                  }}
                /> */}
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-quality">{t("common:quality")} </h2>
                {/* TODO */}
                <Stack direction="row" spacing={1} alignItems="center" color="warning.main" mb={2}>
                  <WarningIcon fontSize="small" />{" "}
                  <Typography variant="body2">{t("page:body.toMergeWithTableCellChip")}</Typography>
                </Stack>
                <TableCellQuality data={{ value: ["4K"] }} />
                <TableCellQuality data={{ value: ["4K HDR"] }} />
              </Grid>
              <Grid item md={4}>
                <h2 id="cell-subtitle">{t("page:body.cellSubtitle")}</h2>
                <Stack spacing={2}>
                  <TableCellDescription
                    title={t("table:cellTitle.qualifyHumanTask")}
                    description={t("table:cellDescription.convertSubtitleFile")}
                  />
                  <TableCellDescription
                    color="error"
                    title={t("table:cellTitle.qualifyHumanTask")}
                    description={t("table:cellDescription.convertSubtitleFile")}
                  />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                {" "}
                <h2 id="cell-name-bar">{t("page:body.cellProgressBar")}</h2>
                <TableCellName data={{ value: { firstname: "Alexander", lastname: "Hamilton", id: 12345678 } }} />
              </Grid>
              {/*<Grid item xs={4}>
                <TableCellUserGroups
                  data={{
                    value: [
                      { groupRole: GroupRole.Provider, name: "Eclair" },
                      { groupRole: GroupRole.Provider, name: "Dubbing Brothers" },
                      { groupRole: GroupRole.Servicer, name: "Movies <1990" },
                    ],
                  }}
                />
                </Grid>*/}
              <Grid item xs={4}>
                <h2 id="cell-progress-bar">{t("page:body.cellProgressBar")}</h2>
                <Paper sx={{ p: 2 }}>
                  <Stack spacing={2}>
                    <TableCellProgressBar progress={65} />
                    <TableCellProgressBar progress={32} />
                    <TableCellProgressBar
                      progress={17}
                      subtitle={t("table:cellProgressBar.approvedCount", { approved: 12, total: 67 })}
                    />
                  </Stack>
                </Paper>
              </Grid>
              <Grid item md={4}>
                <h2 id="share-status">{t("page:body.shareStatus")}</h2>
                <Stack direction="row" spacing={2} mb={2}>
                  <TableCellShareStatus data={{ value: false, nbViews: 30, transcoding: false }} />
                  <TableCellShareStatus data={{ value: true, nbViews: 30, transcoding: false }} />
                </Stack>
              </Grid>

              <Grid item md={4}>
                <h2 id="package-bundle-status">{t("page:body.packageBundleStatus")}</h2>
                <Stack spacing={1}>
                  <TableCellPackageBundleStatus status={AssetSelectStatus.Ok} />
                  <TableCellPackageBundleStatus status={AssetSelectStatus.MissingAsset} />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <h2 id="provider-status">{t("page:body.providerStatus")}</h2>
                <Stack direction="row" spacing={2} mb={2}>
                  <TableCellProviderStatus data={{ value: "pending" }} />
                  <TableCellProviderStatus data={{ value: "manual-rejected" }} />
                  <TableCellProviderStatus data={{ value: "auto-rejected" }} />
                  <TableCellProviderStatus data={{ value: "accepted" }} />
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <h2 id="order-status">{t("page:body.orderStatus")}</h2>
                <Stack direction="row" spacing={2} mb={2}>
                  <TableCellOrderStatus data={{ value: "processing" }} />
                  <TableCellOrderStatus data={{ value: "delivered" }} />
                  <TableCellOrderStatus data={{ value: "fixing" }} />
                  <TableCellOrderStatus data={{ value: "error" }} />
                  <TableCellOrderStatus data={{ value: "-" }} />
                </Stack>
                <Stack direction="row" spacing={2}>
                  <Box sx={{ width: "150px" }}>
                    <TableCellOrderStatus showProgressBar data={{ value: "processing" }} />
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <TableCellOrderStatus showProgressBar data={{ value: "delivered" }} />
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <TableCellOrderStatus showProgressBar data={{ value: "fixing" }} />
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <TableCellOrderStatus showProgressBar data={{ value: "error" }} />
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <TableCellOrderStatus showProgressBar data={{ value: "-" }} />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, mt: 4, display: "flex", flexDirection: "column", backgroundImage: "none" }}>
            <h1 id="table">Tables</h1>
            <h2 id="skeleton-table">{t("page:body.tableSkeleton")}</h2>
            <TableSkeleton />
            <h2 id="request-configuration-table">{t("page:body.requestConfigurationTable")}</h2>
            <Tabs value={expandedGroupColumn} onChange={(e, group) => onChangeExpandedGroupColumn(group, false)}>
              <Tab label={t("common:overview")} value="overview" />
              <Tab label={t("common:settings")} value="settings" />
              <Tab label={t("modal:modalComposePackageBundle.body.audioMapping")} value="audioMapping" />
              <Tab label={t("common:pictureOptions")} value="pictureOptions" />
              <Tab label={t("page:tab.label.deliveryOptions")} value="deliveryOptions" />
            </Tabs>
            <h2 id="contents-table">{t("page:body.contentsTable")}</h2>
            {/* <ContentsTable rows={TitleData.contentDetails} action={{ label: "Action", onClick: () => {} }} /> */}
            {/*<h2 id="titles-table">Titles Table</h2>
            <TitlesTable pageSize={4} rows={BrowsingData.movie}  />
            <h2 id="table-row-ordering">Table - Row ordering</h2>
            <TitlesTable rowReordering pageSize={4} rows={BrowsingData.movie} columns={[]} />*/}
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default DemoTables;
